import { SortingState } from '@tanstack/react-table';

import { Sorting } from '../../../types';
import { convertSortingStateToSorting } from '../../../utils/tables';

export const convertReactTableSortingStateToSorting = (
  sortingState: SortingState,
): Sorting | undefined => convertSortingStateToSorting(sortingState);

export const convertSortingToReactTableSortingState = (
  sorting: Sorting,
): SortingState => [
  {
    desc: sorting.direction === 'desc',
    id: sorting.column,
  },
];
